import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

export const EmployeeBannerField = ({ label, value, color }: { label: string; value: any; color?: string }) => (
    <Box display="flex" alignItems="flex-start" gap={1} textAlign="left">
        <Typography variant="h6" fontSize="14px" fontWeight="bold">
            {label}:
        </Typography>
        <Typography fontSize="12px" fontWeight={500} color={color}>
            {value}
        </Typography>
    </Box>
);